var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 289.848,
    height: 278.191,
    viewBox: "0 0 289.848 278.191",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20560",
    "data-name": "Rectangle 20560",
    width: 204.061,
    height: 136.888,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20548",
    "data-name": "Rectangle 20548",
    width: 57.747,
    height: 40.007,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20563",
    "data-name": "Rectangle 20563",
    width: 14.853,
    height: 21.751,
    fill: "#dd9d15"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20565",
    "data-name": "Rectangle 20565",
    width: 15.296,
    height: 28.992,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20566",
    "data-name": "Rectangle 20566",
    width: 12.813,
    height: 21.023,
    fill: "#dd9d15"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Manage",
    transform: "translate(-170.452 -25.254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75353",
    "data-name": "Path 75353",
    d: "M-14120.776-21146.443l.178,1.037,14,81.7-.429.266-110.245,68.408-.145.025-76.875,13.049-.184-.646-40.846-144.381,1.214.254,128.358,27Zm12.533,81.992-13.656-79.664-83.61,45.967-.272-.057-127.416-26.8,39.986,141.346,75.4-12.8Z",
    transform: "translate(14541 21230)",
    fill: "#0b3454",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46617",
    "data-name": "Group 46617",
    transform: "translate(211.97 166.557)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46616",
    "data-name": "Group 46616",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75196",
    "data-name": "Path 75196",
    d: "M3.992,80.064,0,167.688H75.548L60.485,80.064Z",
    transform: "translate(0 -34.689)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75197",
    "data-name": "Path 75197",
    d: "M3.992,80.064,0,167.688H6.624l3.717-87.624Z",
    transform: "translate(0 -34.689)",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46613",
    "data-name": "Group 46613"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46612",
    "data-name": "Group 46612",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75198",
    "data-name": "Path 75198",
    d: "M88.944,2.4c7.843,1.365,11.738,11.219,13.519,19.8s.766,15.467,6.686,19.889c0,0-4.875,8.934-23.665,10.363-15.6,1.187-24.416-2.149-24.416-2.149a87.929,87.929,0,0,1-2.494-19.346c0-10.508,2.732-21.4,9.9-26.332C80.445-3.6,88.944,2.4,88.944,2.4",
    transform: "translate(-25.378 -0.126)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75199",
    "data-name": "Path 75199",
    d: "M112.162,4.02a12.3,12.3,0,0,1,5.119,2.527,16.364,16.364,0,0,1,3.791,4.219,35.785,35.785,0,0,1,4.187,10.613c.982,3.726,1.588,7.552,2.517,11.351a28.708,28.708,0,0,0,1.878,5.58,9.463,9.463,0,0,0,3.917,4.3,9.721,9.721,0,0,1-3.4-4.531,28.922,28.922,0,0,1-1.523-5.539c-.707-3.791-1.287-7.652-2.254-11.449a31.979,31.979,0,0,0-4.567-10.841,17.083,17.083,0,0,0-4.2-4.173,11.688,11.688,0,0,0-5.463-2.054",
    transform: "translate(-48.595 -1.742)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75200",
    "data-name": "Path 75200",
    d: "M72.891,3.081A21.474,21.474,0,0,0,62.61,11.389a32,32,0,0,0-4.9,12.778,53.174,53.174,0,0,0-.177,13.746q.7,6.812,2.005,13.513l-.619-6.8c-.209-2.263-.4-4.527-.53-6.791a56.441,56.441,0,0,1,.427-13.474,32.467,32.467,0,0,1,4.5-12.465A24.833,24.833,0,0,1,67.5,6.814a20.361,20.361,0,0,1,5.386-3.733",
    transform: "translate(-24.773 -1.335)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75201",
    "data-name": "Path 75201",
    d: "M79.816,97.754c6.039,5.279,36.859,30.048,48.983,26.357,14.689-4.472,30.529-12.731,36.724-19.832C169,100.3,149.671,81.2,146.106,84.379,140.48,89.4,126.632,98.161,124.17,99.421s-25.128-7.89-38.146-11.09c-11.728-2.883-10.463,5.7-6.208,9.423",
    transform: "translate(-33.265 -36.404)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75202",
    "data-name": "Path 75202",
    d: "M228.237,83.18c-3.679,4.873-15.1,11.9-18.506,12.531S193.738,77.327,194.883,73.96s14.8-18.814,20.838-20.349,16.327,24.521,12.516,29.57",
    transform: "translate(-84.403 -23.199)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75203",
    "data-name": "Path 75203",
    d: "M198.227,61.652a50.616,50.616,0,0,0,1.752-14.618c-.363-5.872-1.566-14.55,1.584-14.863,6.467-.644,9.459,21,9.459,21s-.213,9.76-6.563,10.966a6.419,6.419,0,0,1-6.231-2.483",
    transform: "translate(-85.884 -13.932)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75204",
    "data-name": "Path 75204",
    d: "M215.584,53.751c-.332,3.218,3.65,1.767,3.65,1.767s-5.229,3.47-4.287,6.92c.916,3.322,5.664,1.4,6.006,1.267-.275.186-5,3.5-3.694,6.869,1.357,3.5,5.793.752,6.078.574-.2.257-2.851,3.7-1.28,6.037,2.7,4.011,9.713-4.613,13.622-4.851,0,0,1.159,6.578,1.233,6.762,0,0,6.838-8.068,6.222-13.322a3.378,3.378,0,0,0-2.97-3.014s2.492-2.358,1.55-5.043c-.487-1.377-3.123-1.823-3.123-1.823a4.232,4.232,0,0,0,.929-4.307c-.782-1.867-3.3-2.024-3.3-2.024s.962-2.746-.456-4.394c-2.852-3.33-19.462,1.693-20.179,8.583",
    transform: "translate(-93.079 -19.113)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75205",
    "data-name": "Path 75205",
    d: "M238.967,53.506a.046.046,0,0,0-.009-.091,30.1,30.1,0,0,0-16.8,6.188c-.151.122-.018.419.174.317a61.641,61.641,0,0,1,16.638-6.414",
    transform: "translate(-96.222 -23.143)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75206",
    "data-name": "Path 75206",
    d: "M243.086,64.7c.066-.014.044-.124-.029-.12a28.192,28.192,0,0,0-17.911,7.889c-.164.169-.143.485.061.3,3.43-3.025,12.39-6.915,17.878-8.074",
    transform: "translate(-97.5 -27.982)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75207",
    "data-name": "Path 75207",
    d: "M229.322,85.753c4.772-4.533,10.516-7.08,16.793-8.847.082-.023.041-.136-.032-.135-3.306.028-7.189,1.572-10.11,3.029a17.353,17.353,0,0,0-6.809,5.788c-.069.1.057.264.158.167",
    transform: "translate(-99.279 -33.261)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75208",
    "data-name": "Path 75208",
    d: "M218.574,64.184c-.181.147.232.249.057.4-.74.64-4.863,4.88-3.854,6.732.812,1.483,3.368,1.421,4.34,1.013l2.445-1.027-1.939,1.816a10.856,10.856,0,0,0-2.168,2.767,3.883,3.883,0,0,0-.432,3.144,2.217,2.217,0,0,0,2.311,1.565,6.7,6.7,0,0,0,3.147-1.181l2.632-1.717-1.917,2.473a10.22,10.22,0,0,0-1.322,2.242,4.194,4.194,0,0,0-.366,2.4,2,2,0,0,0,1.419,1.555,4.419,4.419,0,0,0,2.441-.383,34.74,34.74,0,0,0,4.775-2.623c.787-.477,1.576-.957,2.388-1.4a6.571,6.571,0,0,1,2.6-.93,7.086,7.086,0,0,0-2.467,1.149c-.768.5-1.513,1.033-2.261,1.568a29.57,29.57,0,0,1-4.738,2.935,5.155,5.155,0,0,1-2.913.551,2.833,2.833,0,0,1-2.183-2.213,5.138,5.138,0,0,1,.375-2.986,11.176,11.176,0,0,1,1.435-2.518l.715.755a7.7,7.7,0,0,1-3.7,1.432,3.215,3.215,0,0,1-2.1-.571,3.632,3.632,0,0,1-1.265-1.737,4.9,4.9,0,0,1,.546-3.981A11.762,11.762,0,0,1,219,72.406l.506.788c-1.254.477-4.1.858-5.651-1.284-1.6-3.093,3.7-7.068,4.72-7.726",
    transform: "translate(-92.525 -27.808)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75209",
    "data-name": "Path 75209",
    d: "M219.414,60.722a6.51,6.51,0,0,1-1.985,0,1.5,1.5,0,0,1-1.2-.929,3.06,3.06,0,0,1,.079-1.735c.182-.626.4-1.274.662-1.935a5.153,5.153,0,0,0-1.322,1.682,3.029,3.029,0,0,0-.27,2.3,2.154,2.154,0,0,0,.812,1,2.245,2.245,0,0,0,1.178.319,3.478,3.478,0,0,0,2.052-.705",
    transform: "translate(-93.258 -24.317)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75210",
    "data-name": "Path 75210",
    d: "M141.094,88.732l25.141,25.617s-31.271,16.475-41.768,15.063-33.745-17.145-44.089-27.737S75.358,87.4,88.7,90.486s32.385,9.759,34.235,9.5,18.157-11.25,18.157-11.25",
    transform: "translate(-32.469 -38.444)",
    fill: "#f8b018"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75211",
    "data-name": "Path 75211",
    d: "M203.235,120.388c-1.1-1.6-2.527-3.024-3.78-4.5-1.294-1.529-2.646-3.011-3.993-4.493-2.62-2.886-5.337-5.687-8.055-8.48-1.582-1.627-3.227-3.186-4.827-4.792-.058-.058-.159.036-.105.1,2.591,3,5.144,6.029,7.8,8.977,2.61,2.9,5.26,5.759,7.991,8.542.78.8,1.589,1.563,2.376,2.352a32.021,32.021,0,0,0,2.481,2.4.077.077,0,0,0,.111-.1",
    transform: "translate(-79.053 -42.503)",
    fill: "#263238",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46611",
    "data-name": "Group 46611",
    transform: "translate(42.471 51.045)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46610",
    "data-name": "Group 46610"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46609",
    "data-name": "Group 46609",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75212",
    "data-name": "Path 75212",
    d: "M132.686,129a23.257,23.257,0,0,1-8.218.986c-10.5-1.411-33.749-17.144-44.092-27.736-7.447-7.623-6.773-11.669-.833-12.185Z",
    transform: "translate(-74.939 -90.068)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_75213",
    "data-name": "Path 75213",
    d: "M81.25,171.182H13.067S25.114,111.031,39.53,94.1c.322-.391.655-.759.988-1.1.069-.08.126-.138.2-.207a15.406,15.406,0,0,1,3.852-2.978c.253-.138.506-.264.77-.379,5.553-2.552,11.416-.437,15.647,3.185,1.345,1.15,16.544,25.331,17.889,32.873,1.161,6.656-2.866,12.372-2.866,12.372Z",
    transform: "translate(-5.661 -38.26)",
    fill: "#f8b018"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75214",
    "data-name": "Path 75214",
    d: "M90.56,165.947a62.108,62.108,0,0,0-9.058,1.571c-1.474.392-2.92.849-4.364,1.339-.72.244-1.443.463-2.171.679a9.776,9.776,0,0,1-2.333.461.055.055,0,0,0,0,.109,16.579,16.579,0,0,0,2.251-.062,16.148,16.148,0,0,0,2.142-.423c1.5-.383,2.979-.835,4.474-1.233,3.016-.8,6.031-1.606,9.1-2.19.141-.027.1-.268-.04-.252",
    transform: "translate(-31.447 -71.898)",
    fill: "#263238",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75215",
    "data-name": "Path 75215",
    d: "M106.064,170.37a67.309,67.309,0,0,0-7.581-.3c-1.267.027-2.521.126-3.781.259-.6.063-1.2.138-1.8.219-.659.09-1.307.269-1.967.349-.069.008-.068.116,0,.109.625-.057,1.262-.01,1.889-.031s1.26-.046,1.891-.067c1.262-.042,2.523-.07,3.785-.124,2.526-.108,5.041-.189,7.569-.209.137,0,.125-.2-.005-.208",
    transform: "translate(-39.376 -73.68)",
    fill: "#263238",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75217",
    "data-name": "Path 75217",
    d: "M98.7,133.377a1.074,1.074,0,0,1-.985,1.1.983.983,0,0,1-1.058-.956,1.073,1.073,0,0,1,.985-1.1.983.983,0,0,1,1.058.956",
    transform: "translate(-41.876 -57.372)",
    fill: "#263238",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75218",
    "data-name": "Path 75218",
    d: "M90.6,118.829a1.074,1.074,0,0,1-.985,1.1.983.983,0,0,1-1.058-.957,1.073,1.073,0,0,1,.985-1.1.983.983,0,0,1,1.058.956",
    transform: "translate(-38.369 -51.068)",
    fill: "#263238",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75219",
    "data-name": "Path 75219",
    d: "M105.834,152.039a1.073,1.073,0,0,1-.985,1.1.983.983,0,0,1-1.058-.956,1.074,1.074,0,0,1,.985-1.1.983.983,0,0,1,1.058.956",
    transform: "translate(-44.968 -65.457)",
    fill: "#263238",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75220",
    "data-name": "Path 75220",
    d: "M102.3,172.612a1.074,1.074,0,0,1-.985,1.1.983.983,0,0,1-1.058-.956,1.073,1.073,0,0,1,.985-1.1.982.982,0,0,1,1.058.956",
    transform: "translate(-43.437 -74.37)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75221",
    "data-name": "Path 75221",
    d: "M98.628,188.908a1.074,1.074,0,0,1-.985,1.1.983.983,0,0,1-1.058-.956,1.073,1.073,0,0,1,.985-1.1.982.982,0,0,1,1.058.956",
    transform: "translate(-41.846 -81.431)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75222",
    "data-name": "Path 75222",
    d: "M96.824,207.656a1.073,1.073,0,0,1-.985,1.1.983.983,0,0,1-1.058-.956,1.073,1.073,0,0,1,.985-1.1.983.983,0,0,1,1.058.956",
    transform: "translate(-41.065 -89.554)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75223",
    "data-name": "Path 75223",
    d: "M96.072,226.052a1.073,1.073,0,0,1-.985,1.1.983.983,0,0,1-1.058-.957,1.073,1.073,0,0,1,.985-1.1.982.982,0,0,1,1.058.956",
    transform: "translate(-40.739 -97.524)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75224",
    "data-name": "Path 75224",
    d: "M33.828,100.109c-13.5,19-31.012,51.944-22,58,14.809,9.964,55.557,12.645,64.871,12.878,4.02.1,9.509-26.627,6.537-29.735s-45.628-1.449-46.173-4.024c-.309-1.46,4.911-14.926,7.559-31.082,3.053-18.628-6.985-11.4-10.79-6.042",
    transform: "translate(-4.052 -40.783)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75225",
    "data-name": "Path 75225",
    d: "M122.644,173.312s12.167-1.25,20.162-1.693c4.461-.247,12.146.011,15.506,1.328,5.026,1.97,24.787,13.42,22.114,18.271-2.42,4.392-18.148-7.6-18.148-7.6s16.941,10.7,13.055,15.45-19.855-11.161-19.855-11.161,17.16,11.383,12.378,15.649c-3.614,3.224-18.889-10.374-18.889-10.374s14.681,9.886,11.108,13.361c-3.948,3.841-18.836-7.826-18.836-7.826-10.571,7.306-18.593,6.46-24.228,5.179-1.364-.31,5.633-30.584,5.633-30.584",
    transform: "translate(-50.619 -74.319)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75226",
    "data-name": "Path 75226",
    d: "M187.043,185.657c2.035,1.184,4.1,2.37,6.027,3.731s3.8,2.792,5.588,4.326a40.256,40.256,0,0,1,6.388,6.633c-3.635-4.1-10.444-9.082-12.368-10.444s-3.771-2.814-5.69-4.175c-.049-.035.006-.1.054-.071",
    transform: "translate(-81.006 -80.435)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75227",
    "data-name": "Path 75227",
    d: "M178.156,197.753c2.533,1.625,5.109,3.145,7.571,4.884s5.8,4.269,8.129,6.162c.179.146.044.464-.142.325-2.4-1.8-5.937-4.232-8.357-6s-4.772-3.636-7.245-5.311c-.039-.026.005-.082.044-.057",
    transform: "translate(-77.163 -85.676)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75228",
    "data-name": "Path 75228",
    d: "M168.614,206.758a67.25,67.25,0,0,1,11.006,8.353c.171.152-.014.194-.2.05-3.606-2.846-6.414-5.1-10.888-8.264-.07-.049,0-.187.08-.139",
    transform: "translate(-73.006 -89.576)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75229",
    "data-name": "Path 75229",
    d: "M69.714,138.15l-10.95,34.7S7.858,163.984,6.8,153.724s13.624-39.631,27.055-56.214c7.067-8.726,12.63-7.224,10.147,7.9s-6.77,30.013-6.629,30.3,32.341,2.445,32.341,2.445",
    transform: "translate(-2.923 -39.931)",
    fill: "#f8b018"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75230",
    "data-name": "Path 75230",
    d: "M86.474,204.945c.862-1.738,1.416-3.678,2.1-5.492.708-1.874,1.346-3.775,1.988-5.672,1.25-3.692,2.378-7.427,3.5-11.16.653-2.172,1.217-4.368,1.844-6.547.023-.079-.109-.121-.138-.044-1.367,3.723-2.771,7.425-4.058,11.178-1.265,3.689-2.478,7.395-3.585,11.135-.316,1.068-.594,2.148-.9,3.219a31.938,31.938,0,0,0-.9,3.336.077.077,0,0,0,.145.046",
    transform: "translate(-37.402 -76.249)",
    fill: "#263238",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75231",
    "data-name": "Path 75231",
    d: "M64.668,222.041c-.277.9-.556,1.8-.852,2.691l-.033.1-.116-.014c-3.941-.466-7.849-1.143-11.741-1.9-3.887-.784-7.756-1.672-11.589-2.7-3.827-1.05-7.631-2.2-11.36-3.568A82.875,82.875,0,0,1,18.111,211.8c3.663,1.519,7.391,2.817,11.143,4.039,3.764,1.188,7.56,2.27,11.373,3.292s7.654,1.948,11.5,2.844,7.709,1.758,11.58,2.579l-.149.087c.358-.87.732-1.734,1.107-2.6",
    transform: "translate(-7.847 -91.763)",
    fill: "#263238",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75232",
    "data-name": "Path 75232",
    d: "M92.5,153.842l.116-.44.019.028c-2.706-.056-5.409-.15-8.111-.256s-5.4-.252-8.1-.4c-2.7-.164-5.4-.319-8.1-.523l-4.047-.306-2.024-.184-1.016-.1-.514-.061-.271-.04c-.054-.009-.073-.009-.155-.027a1.37,1.37,0,0,1-.319-.12l-.321-.169.1-.413q1.449-5.87,2.954-11.728l1.513-5.857c.513-1.95,1-3.9,1.484-5.865-.269,2-.653,3.985-1.018,5.97s-.783,3.96-1.2,5.934q-1.262,5.92-2.666,11.806l-.219-.581,15.878,1.3,7.228.655.849.077c2.691.265,5.382.536,8.071.84l.028,0-.009.025Z",
    transform: "translate(-25.849 -55.19)",
    fill: "#263238",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75233",
    "data-name": "Path 75233",
    d: "M69.331,132.418a8.425,8.425,0,0,1-.3,1.61,15.253,15.253,0,0,1-.52,1.542,12.807,12.807,0,0,1-1.555,2.86,14.458,14.458,0,0,1,.464-1.562c.175-.51.369-1.01.565-1.509a29.179,29.179,0,0,1,1.35-2.941",
    transform: "translate(-29.008 -57.371)",
    fill: "#263238",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75234",
    "data-name": "Path 75234",
    d: "M76.255,76.368c.268,1.259,4.914,9.561,10.646,9.407,1.867-.053,3.2-10.305,3.2-10.305l.185-.75L92.86,64.212l-12.238-8.2-1.77-1.089s-.514,2.921-1.117,6.565c-.029.169-.058.338-.087.519-.04.205-.079.4-.107.592-.1.543-.194,1.1-.279,1.653-.066.422-.133.832-.186,1.277s-.12.88-.185,1.326a69.679,69.679,0,0,0-.635,9.516",
    transform: "translate(-33.026 -23.795)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75235",
    "data-name": "Path 75235",
    d: "M78.885,61.486A21.7,21.7,0,0,0,91.44,74.72l2.571-10.507-12.238-8.2L80,54.921s-.513,2.921-1.117,6.565",
    transform: "translate(-34.178 -23.795)",
    fill: "#bc6156"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75236",
    "data-name": "Path 75236",
    d: "M105.5,25.846c1.272,18.941-9.929,21.842-14.014,22.111-3.708.245-16.365.608-19.587-18.1S77.085,4.569,85.535,3.56,104.231,6.9,105.5,25.846",
    transform: "translate(-30.847 -1.484)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75247",
    "data-name": "Path 75247",
    d: "M71.035,27.715c4.129.116,5.345-8.274,5.345-8.274s4.693-.336,5.18-7.888a11.454,11.454,0,0,0,8.5,5.656c1.34.222-3.1-3.347-3.1-3.347s5.306,4.988,15.359,3.323c.711-.118.2-11.722-7.595-15.476S79.013.875,74.056,5.74c0,0-6.349,3.757-7.1,9.2S69.43,27.67,71.035,27.715",
    transform: "translate(-28.962 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75248",
    "data-name": "Path 75248",
    d: "M71.9,46.1S67.872,40.1,65.155,41.52s.23,10.074,3.364,11.31a3.21,3.21,0,0,0,4.334-1.641Z",
    transform: "translate(-27.765 -17.894)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75249",
    "data-name": "Path 75249",
    d: "M67.537,46.025a.044.044,0,0,0-.019.084c2.2.94,3.321,3.014,4.1,5.158a1.773,1.773,0,0,0-2.642-.536c-.058.04,0,.131.058.12a1.975,1.975,0,0,1,2.159.732A9.54,9.54,0,0,1,72.2,53.36c.1.2.458.1.388-.129l-.017-.052c.111-2.82-2.005-6.811-5.029-7.155",
    transform: "translate(-29.241 -19.941)",
    fill: "#bc6156"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75250",
    "data-name": "Path 75250",
    d: "M86.675,91.816,83.4,100.362,72.679,89.789l-2.934,3.5s10.6,16.9,10.648,16.128l3.381-7.374,5.134,5.009-.617-12.775Z",
    transform: "translate(-30.218 -38.902)",
    fill: "#f8b018"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75251",
    "data-name": "Path 75251",
    d: "M89.3,103.986c-.172-2.106-.287-4.231-.557-6.327-.01-.074-.127-.106-.143-.018-.39,2.043.313,10.093.335,12.025l-.023-.022c-.214-.217-4.754-4.4-4.8-4.336-.74,1.174-3.221,6.545-3.39,7.033-1.675-2.685-8.09-12.439-10.063-14.97a.073.073,0,0,0-.125.075c1.488,2.839,9.98,15.976,10.107,15.937a82.493,82.493,0,0,0,3.534-7.8c.772.916,5.362,5.65,5.372,5.336a66.065,66.065,0,0,0-.249-6.937",
    transform: "translate(-30.554 -42.173)",
    fill: "#263238",
    opacity: 0.4
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20550",
    "data-name": "Rectangle 20550",
    width: 4.145,
    height: 2.706,
    transform: "translate(91.998 129.003)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20551",
    "data-name": "Rectangle 20551",
    width: 4.145,
    height: 2.706,
    transform: "translate(97.373 128.823)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20552",
    "data-name": "Rectangle 20552",
    width: 4.145,
    height: 2.706,
    transform: "translate(102.747 128.645)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20553",
    "data-name": "Rectangle 20553",
    width: 4.145,
    height: 2.706,
    transform: "translate(108.122 128.466)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20554",
    "data-name": "Rectangle 20554",
    width: 4.145,
    height: 2.706,
    transform: "translate(113.497 128.287)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20555",
    "data-name": "Rectangle 20555",
    width: 4.145,
    height: 2.706,
    transform: "translate(118.872 128.108)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20556",
    "data-name": "Rectangle 20556",
    width: 4.145,
    height: 2.706,
    transform: "translate(124.246 127.93)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20557",
    "data-name": "Rectangle 20557",
    width: 4.145,
    height: 2.706,
    transform: "translate(129.621 127.751)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20558",
    "data-name": "Rectangle 20558",
    width: 4.145,
    height: 2.706,
    transform: "translate(134.996 127.572)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75252",
    "data-name": "Path 75252",
    d: "M209.71,231.578H160.537v-3.293l49.173-1.371Z",
    transform: "translate(-69.554 -98.313)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75253",
    "data-name": "Path 75253",
    d: "M269.927,166.032H188.751L201.66,105.6h81.176Z",
    transform: "translate(-81.778 -45.752)",
    fill: "#2b516f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75254",
    "data-name": "Path 75254",
    d: "M206.959,105.6l-12.91,60.434h81.176L288.135,105.6Z",
    transform: "translate(-84.074 -45.751)",
    fill: "#0b3454"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46615",
    "data-name": "Group 46615"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46614",
    "data-name": "Group 46614",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75255",
    "data-name": "Path 75255",
    d: "M281.711,148.9a6.109,6.109,0,0,1-5.815,5.019,4.177,4.177,0,0,1-4.224-5.019,6.108,6.108,0,0,1,5.814-5.019,4.178,4.178,0,0,1,4.224,5.019",
    transform: "translate(-117.677 -62.338)",
    fill: "#2b516f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75256",
    "data-name": "Path 75256",
    d: "M266.252,236.725H226.327v-3.1l39.925-1.29Z",
    transform: "translate(-98.058 -100.661)",
    fill: "#0b3454"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75257",
    "data-name": "Path 75257",
    d: "M289.67,214.186H268.234l-12.91-33.864H276.76Z",
    transform: "translate(-110.622 -78.126)",
    fill: "#0b3454"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75258",
    "data-name": "Path 75258",
    d: "M295.9,214.186H274.459l-12.91-33.864h21.436Z",
    transform: "translate(-113.319 -78.126)",
    fill: "#2b516f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75259",
    "data-name": "Path 75259",
    d: "M125.563,230.448H84.4c-3.514,0,1.57-10,14.39-13.84s30.815,10.087,26.772,13.84",
    transform: "translate(-36.098 -93.561)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75260",
    "data-name": "Path 75260",
    d: "M129.358,233.167a12.7,12.7,0,0,1,.575-3.352,14.228,14.228,0,0,1,1.389-3.131,11.385,11.385,0,0,1,2.179-2.653,9.819,9.819,0,0,1,2.884-1.81q-.343.254-.69.491l-.345.238-.318.274-.638.535-.585.59a14.243,14.243,0,0,0-2,2.628,19.463,19.463,0,0,0-1.458,2.982,23.942,23.942,0,0,0-.991,3.208",
    transform: "translate(-56.046 -96.279)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75261",
    "data-name": "Path 75261",
    d: "M137.964,224.742a26.5,26.5,0,0,1,6.852,3.43,14.873,14.873,0,0,1,2.868,2.6,8.871,8.871,0,0,1,1.065,1.629,4.834,4.834,0,0,1,.49,1.863,5.407,5.407,0,0,0-.734-1.731,8.742,8.742,0,0,0-1.148-1.474,19.862,19.862,0,0,0-2.87-2.422c-1.02-.738-2.1-1.4-3.186-2.047-.544-.324-1.1-.634-1.657-.936-.551-.317-1.118-.606-1.681-.908",
    transform: "translate(-59.774 -97.372)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46619",
    "data-name": "Group 46619",
    transform: "translate(385.03 122.045)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46637",
    "data-name": "Group 46637",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75262",
    "data-name": "Path 75262",
    d: "M62.395,68.095A25.117,25.117,0,1,1,87.512,42.978,25.145,25.145,0,0,1,62.395,68.095",
    transform: "translate(-12.896 -6.178)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75263",
    "data-name": "Path 75263",
    d: "M62.049,18.168A24.463,24.463,0,1,1,37.586,42.631,24.463,24.463,0,0,1,62.049,18.168m0-1.308A25.771,25.771,0,1,0,87.82,42.631,25.8,25.8,0,0,0,62.049,16.86",
    transform: "translate(-12.55 -5.833)",
    fill: "#0b3454"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75264",
    "data-name": "Path 75264",
    d: "M30.558,48.615c-2.218,1.965-11.269,9.311-11.269,9.311-1.237-2.513-2.68-5.587-3.89-8.241a33.231,33.231,0,0,1-2.451-9.122,23.3,23.3,0,0,0-.778-3.488,10.1,10.1,0,0,1-.319-3.62c.086-.593-1.423-.807-2.177.969a13.343,13.343,0,0,0-.61,3.741c-.656-.37-1.614-1.094-3.053-1.866s-3.642-2.461-4.774-.878c-.445.621.033,1.28-.005,1.483s-.266.319-.406.473a2.191,2.191,0,0,0-.415,2.2,1.32,1.32,0,0,1,.139.515c-.018.356-.332.631-.447.954a2.2,2.2,0,0,0-.045,1.169c.118.572.373,1.107.492,1.678a6.763,6.763,0,0,0,.268,1.057,2.953,2.953,0,0,0,1.43,1.771c.929.541,1.9,1.12,3.248,1.884,1.068.6,1.57,2.33,2.224,5.161,1.8,6.628,1.931,10.909,3.557,14.507,2.109,4.669,5.287,4.01,11.175.708,7.237-4.059,12.461-6.857,12.461-6.857l5.844-18.714c-3.72.251-7.98,3.243-10.2,5.207",
    transform: "translate(0 -11.425)",
    fill: "#ffa8a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75265",
    "data-name": "Path 75265",
    d: "M55.945,47.384c-5,.2-6.036,1.11-8.947,2.979s-11.35,9.294-11.35,9.294a20.127,20.127,0,0,0,6.372,10.7L51.5,64.895Z",
    transform: "translate(-12.332 -16.392)",
    fill: "#dd9d15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75266",
    "data-name": "Path 75266",
    d: "M8,41.054c1.1.471,1.334,1.25,1.139,2.872-.115.961-.006,2.769.97,3.587A2.508,2.508,0,0,1,8.8,46.786c-.445-.558-.576-.629-.879-.366a1.822,1.822,0,0,1-.766.344,1.255,1.255,0,0,1-.033,1.5c-.587.783-3.135.157-4.892-.983,0,0,3.2,1.653,3.991.769s-.966-2.659-2.12-3.1c0,0,3.119,1.4,3.657.493s-.873-2.166-2.539-2.77c0,0,2.642,1.093,3.134.321A1.492,1.492,0,0,0,8,41.054",
    transform: "translate(-0.773 -14.202)",
    fill: "#f28f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75267",
    "data-name": "Path 75267",
    d: "M29.49,70.548a14.957,14.957,0,0,1,1.652,8.934s1.831-3.991-.377-9.967Z",
    transform: "translate(-10.202 -24.047)",
    fill: "#f28f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75268",
    "data-name": "Path 75268",
    d: "M85.733,69.6A24.453,24.453,0,0,1,53.174,72.4c.131-5.736-.032-10.334.19-12.617C54.293,50.12,56.954,47.5,61.9,47.04l8.2-.6c2.387.6,11.1,3.506,13.421,4.919,1.629.988,2.178,4.67,2.283,10.661.046,2.584.033,4.938-.065,7.581",
    transform: "translate(-18.395 -16.064)",
    fill: "#f8b018"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75269",
    "data-name": "Path 75269",
    d: "M56.383,8.912A1.414,1.414,0,0,0,55.1,9.959a2.738,2.738,0,0,0,.152,1.739,4.788,4.788,0,0,0,1.379,1.962,10.756,10.756,0,0,0,2.255,1.153,10.635,10.635,0,0,1,1.432,1.2c.689.525,1.366,1.061,2.067,1.57A44.292,44.292,0,0,0,66.742,20.4a30.754,30.754,0,0,0,4.5,2.086,13.084,13.084,0,0,0,4.178.791l.364,4.178s.579-1.1,1.237-2.416c.568-1.132,2.932-6.882,2.932-6.882a16.24,16.24,0,0,0,1.674-7.144c-.129-2.031-.752-3.543-2.306-4.391a4.944,4.944,0,0,0-1.852-5.01A9.148,9.148,0,0,0,73.4.107a16.445,16.445,0,0,0-4.932.207C63.881,1.076,59.193,2.395,54.8.167a3.825,3.825,0,0,0,.326,2.069,9.873,9.873,0,0,0,2.64,3.75L55.2,5.674a.388.388,0,0,0-.289.04.368.368,0,0,0-.105.272,3.148,3.148,0,0,0,.759,2.257",
    transform: "translate(-18.944 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75270",
    "data-name": "Path 75270",
    d: "M72.725,9.848c.01,1.487,1.451,4.106,3.568,5.928a14.889,14.889,0,0,0-.086,5.021,2.749,2.749,0,0,0,.385,1,1.223,1.223,0,0,0,.887.554c.484.033.682-.264.829-.644a12.311,12.311,0,0,1,.728-1.415,2.815,2.815,0,0,1,.426-.546,2.376,2.376,0,0,1,3.937.786c1.062,2.4-.847,5.595-2.6,6.1-3.025.863-3.7-1.194-3.7-1.194l.117,10.018C76.385,38,71.7,40.5,67.906,40.036s-2.6-2.767-1.072-4.323l-.219-3.48a14.805,14.805,0,0,1-4.038-.12,5.175,5.175,0,0,1-3.847-3.975c-1.272-4.56-.8-11.213-.24-14.082.555-2.831,2.071-4.723,2.922-5.153-.027.614.486,2.092,3.544,2.495,3.245.428,5.444-.572,7.768-1.548",
    transform: "translate(-20.037 -3.08)",
    fill: "#ffa8a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75271",
    "data-name": "Path 75271",
    d: "M71.214,41.464a22.508,22.508,0,0,0,6.643-1.532c2.3-1.16,2.512-3.629,2.767-4.344,0,0,0,3.766-1.943,5.214-2.406,1.792-7.378,2.088-7.378,2.088Z",
    transform: "translate(-24.636 -12.311)",
    fill: "#f28f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75279",
    "data-name": "Path 75279",
    d: "M103.547,64.129a24.586,24.586,0,0,1-11.315,12.9c-.549-2.492-1.563-7.149-1.877-8.889-.445-2.427-1.184-12.244,5.932-14.18a20.825,20.825,0,0,1,4.376,2.695c.634.661,1.727,1.177,2.446,4.879.124.661.275,1.563.438,2.6",
    transform: "translate(-31.166 -18.666)",
    fill: "#dd9d15"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46621",
    "data-name": "Group 46621",
    transform: "translate(170.452 12.85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46638",
    "data-name": "Group 46638",
    transform: "translate(0 18.979)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75282",
    "data-name": "Path 75282",
    d: "M105.162,124.52A38.24,38.24,0,1,0,66.921,86.28a38.283,38.283,0,0,0,38.241,38.239",
    transform: "translate(-65.925 -24.741)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75283",
    "data-name": "Path 75283",
    d: "M105.158,49.031A37.245,37.245,0,1,0,142.4,86.275a37.245,37.245,0,0,0-37.245-37.244m0-1.992A39.237,39.237,0,1,1,65.921,86.275a39.28,39.28,0,0,1,39.237-39.236",
    transform: "translate(-65.921 -24.737)",
    fill: "#0b3454"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75284",
    "data-name": "Path 75284",
    d: "M87.289,65.509a4.582,4.582,0,0,0-2.732.213,29.981,29.981,0,0,0-3.907,2.186c-2,1.088-5.217,2.872-7.532,2.769-.472-.021-1.444-.209-.8-.795a19.851,19.851,0,0,0,2.434-2.362,4.079,4.079,0,0,0,.951-3.156,1.4,1.4,0,0,0-.474-.88c-.388-.289-.655-.106-.961.124a9.533,9.533,0,0,1-1.037.628c-.727.411-1.453.824-2.173,1.246-4.207,2.463-8.416,5.344-10.9,9.658-.361.626-2.534,5.556-3.937,8.337-1.144,2.534-9.8,18.419-9.8,18.419L30.991,86.858c-3.454-3.453-6.9-6.655-9.966-7.831a42.264,42.264,0,0,1-5.355-2.781l5.755,27.231s16.3,12.26,18.624,13.943c3.456,2.5,10.352,6.548,13.775,2.319,4.644-5.736,6.906-14.01,9.077-20.325s3.329-10.146,4.573-12.323,3.286-2.326,4.719-2.774a22.37,22.37,0,0,0,5.661-2.473,20.529,20.529,0,0,0,4.351-3.212,6.326,6.326,0,0,0,1.682-2.017,19.1,19.1,0,0,1,.405-2.151,23.659,23.659,0,0,0,1.308-2.2,7.852,7.852,0,0,0,.131-2.01,3.392,3.392,0,0,1,1.448-2.373,3.183,3.183,0,0,0,.94-1.11c.279-.736-.224-1.094-.832-1.258",
    transform: "translate(40.315 -24.805)",
    fill: "#ffbda7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75285",
    "data-name": "Path 75285",
    d: "M39.266,75.688A23.207,23.207,0,0,1,48.5,80.173c3.708,2.884,22,19.015,22,19.015l7.763-11.317s.129,3,4.473,5.52c4.581,2.655,6.235,1.752,6.235,1.752s-3.4,13.655-7.142,20.372-5.874,8.9-11.985,6.147-26.96-18.305-26.96-18.305Z",
    transform: "translate(16.044 -24.856)",
    fill: "#0d3453"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75286",
    "data-name": "Path 75286",
    d: "M38.581,72.728a14.946,14.946,0,0,1-5.171,6.5,6.191,6.191,0,0,0,3.846-1.964,5.806,5.806,0,0,0,1.325-4.538",
    transform: "translate(72.212 -24.844)",
    fill: "#f0997a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75287",
    "data-name": "Path 75287",
    d: "M62.041,99.281c-2.614,4.528-3.429,10.346-2.887,13.322-1.9-4.792-2.022-9.723,1.206-14.8Z",
    transform: "translate(24.505 -24.949)",
    fill: "#0b262a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75288",
    "data-name": "Path 75288",
    d: "M76.578,96.84c.757,4.571,2.43,12.089,3.545,18.273A37.255,37.255,0,0,0,129,113.839v-5.288s4.252-3.973,3.6-11.342-10.181-19.095-12.7-21.534c-1.983-.786-10.821-2.324-10.821-2.324a86.042,86.042,0,0,0-21.342,2.508c-2.689.7-6.2,1.9-6.2,1.9-1.125,2.958-6.284,11.133-4.959,19.08",
    transform: "translate(-64.596 -24.847)",
    fill: "#0f4e81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75289",
    "data-name": "Path 75289",
    d: "M127.236,45.509c4.1-15.126-9.841-22.862-23.717-20.423-4.57.8-10.468,3.417-11.1,9.929-6.037,1.893-8.941,9.974-5.212,18.6,2.7,6.259,8.107,9.378,10.558,13.219Z",
    transform: "translate(-69.035 -24.643)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75290",
    "data-name": "Path 75290",
    d: "M88.474,47.72c3.879-1.693,5.833,2.367,5.833,2.367,2.521,1.573,3.974-3.485,4.528-5.009.967-2.663,1.881-6.454,4.83-7.557,2.191-.821,4.667-.006,6.674,1.2a5.1,5.1,0,0,0,4.014.534c1.2-.328,1.577-2.2,2.673-2.792,3.153-1.692,5.3,3.564,6.031,5.982A30.356,30.356,0,0,1,124,51.8c-.23,11.271-3.019,16.248-6.142,17.583a15.842,15.842,0,0,1-8.044,1l.055,3.327a15.183,15.183,0,0,1,2.706,11.6C106.3,84.588,97.1,81.15,94.07,75.458l.023-16.712c-.711,1.475-4.053,2.176-6.121-.472-2.681-3.433-3.217-8.929.5-10.554",
    transform: "translate(-65.366 -24.691)",
    fill: "#ffbda7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75293",
    "data-name": "Path 75293",
    d: "M111.479,70.5c-3.651-.562-10.32-2.344-11.428-5.348,0,0-.166,2.441,2.659,4.592,2.358,1.8,8.8,2.919,8.8,2.919Z",
    transform: "translate(-67.026 -24.812)",
    fill: "#f0997a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75301",
    "data-name": "Path 75301",
    d: "M110.438,46.086a3.407,3.407,0,0,1-.76,1.677,1.556,1.556,0,0,0-.3.6,30.7,30.7,0,0,1-1.1,4.477,5.343,5.343,0,0,1-4.814,3.4,6.863,6.863,0,0,1-1.619-.049l-.121-.02a4.328,4.328,0,0,1-1.311-.447c-.027-.014-.054-.029-.078-.044s-.075-.042-.112-.066-.065-.04-.14-.09c-.044-.03-.086-.06-.128-.092s-.1-.071-.141-.109a1.457,1.457,0,0,1-.134-.115,3.052,3.052,0,0,1-.251-.244,5.582,5.582,0,0,1-1.034-1.623c-.662-1.509-.449-3.682-1.577-3.87a.94.94,0,0,0-.135-.012,1.2,1.2,0,0,0-.145,0c-1.538.106-1.4,2.452-2.29,4.18a6.258,6.258,0,0,1-5.667,3.678c-.148.01-.294.015-.432.02-.117,0-.232,0-.343,0a5.82,5.82,0,0,1-.8-.07c-.086-.015-.169-.029-.251-.045s-.163-.037-.239-.056c-.052-.011-.1-.026-.151-.04a4.183,4.183,0,0,1-.9-.375c-.1-.061-.2-.122-.3-.187a3.933,3.933,0,0,1-.515-.429,4.83,4.83,0,0,1-.985-1.508,26.672,26.672,0,0,1-.843-4.335,1.76,1.76,0,0,0-.245-.623,2.766,2.766,0,0,1-.725-1.54,1.49,1.49,0,0,1,.951-1.439q.393-.078.819-.152c2.635-.461,6.071-.788,8.112-.343,2.564.564,3.443,1.338,4.878,1.241,1.342-.1,2.227-1.006,4.676-1.934a22.416,22.416,0,0,1,7.608-.8c.262.009.516.022.758.038.417.027.852.638.79,1.346M93.485,48.611a1.987,1.987,0,0,0-.723-.558,1.331,1.331,0,0,0-.13-.066c-.024-.013-.049-.024-.073-.035-.114-.053-.233-.1-.361-.151-.1-.041-.216-.081-.334-.118a8.944,8.944,0,0,0-1.092-.286c-.141-.029-.289-.056-.435-.079a10.356,10.356,0,0,0-1.128-.117c-.091,0-.18-.009-.264-.006-2.475-.068-4.029.6-4.6,1.138-.59.559-.362,2.83-.144,3.978,0,.029.011.057.016.085s.011.059.017.09c.026.138.059.3.1.463.022.093.048.188.075.287l0,.011c.043.154.1.313.159.477h0c.019.053.043.109.064.162a.911.911,0,0,0,.044.1c.015.037.031.072.049.109s.043.091.067.134.052.1.082.149a1.815,1.815,0,0,0,.1.158c.031.052.068.106.1.158a3.621,3.621,0,0,0,3.439,1.444,5.134,5.134,0,0,0,3.68-1.591h0a5.629,5.629,0,0,0,1.237-2.411c.325-1.318.526-2.843.053-3.523m14.592-2a1.924,1.924,0,0,0-.6-.351.313.313,0,0,0-.046-.018,2.759,2.759,0,0,0-.266-.091c-.052-.015-.108-.031-.163-.044s-.092-.023-.135-.031-.063-.013-.092-.019a.106.106,0,0,0-.034-.006c-.044-.009-.09-.017-.135-.024a5.454,5.454,0,0,0-.568-.064c-.1-.007-.2-.013-.309-.013-.061,0-.122,0-.187,0-.047,0-.1,0-.142,0-.127,0-.261.008-.4.017l-.144.01-.135.012a11.322,11.322,0,0,0-1.145.169c-1.771.352-3.628,1.27-4.121,2.021s-.407,2.253-.2,3.532a5.591,5.591,0,0,0,.209.853c.006.02.014.043.023.066a.907.907,0,0,0,.03.087l.02.057c.013.034.027.069.042.1.03.072.061.139.093.209s.058.118.09.177a.632.632,0,0,0,.034.063c.023.038.045.079.071.119s.041.067.066.1l.01.016a3.608,3.608,0,0,0,3.653,1.48,4.588,4.588,0,0,0,1.86-.545,5.73,5.73,0,0,0,2.473-3.908c.282-1.185.662-3.5.144-3.978",
    transform: "translate(-47.831 -24.727)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75302",
    "data-name": "Path 75302",
    d: "M117.358,46.909l-7.655,1.42a5.938,5.938,0,0,1,1.464,1.54l6.229-1.061Z",
    transform: "translate(-82.522 -24.736)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75304",
    "data-name": "Path 75304",
    d: "M120.279,56.985a1.43,1.43,0,1,1-1.43-1.43,1.43,1.43,0,0,1,1.43,1.43",
    transform: "translate(-93.089 -24.772)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75305",
    "data-name": "Path 75305",
    d: "M110.7,128.49c2.547-.261,4.994-2.607,8.265-3.853,3.289-1.254,6.074-1.279,8.316-2.193.928.53.447,2.481-.656,3.327-1.708,1.309-4.321,2.132-3.7,2.826.922,1.033,4.447.324,5.519.1,3.3-.683,6.8-2.662,10.241-1.932a1.433,1.433,0,0,1,.941.512,1.181,1.181,0,0,1-.265,1.4,7.082,7.082,0,0,1-1.269.87,1.728,1.728,0,0,0-.872,1.206c-.036.468.243.923.184,1.389a1.669,1.669,0,0,1-.4.8,5.489,5.489,0,0,1-1.224,1.127,9.049,9.049,0,0,0-1.131.776,11.944,11.944,0,0,0-2,1.972c-1.8,2.941-5.675,3.825-8.813,4.37-6.712,1.164-9.8-.248-13.759-.171s-20.815-.438-29.472-1.06c-9.07-.65-10.168-2.335-12.725-10.991a248.517,248.517,0,0,1-6.793-30.888c-1.43-10.867.015-16.473,10.758-19.87,3.005,2.054,6.748,9.5,8.566,23.9L84.3,123.831s23.86,4.919,26.407,4.658",
    transform: "translate(-56.023 -24.867)",
    fill: "#ffbda7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75306",
    "data-name": "Path 75306",
    d: "M107.409,77.783c-4.835.95-9.287,2.307-11.775,6.224s-1.591,8.2-.565,16.316,6.621,29.27,8.034,33.776,2.247,5.524,7.058,6.356,29.428,1.064,29.428,1.064-.925-2.142-.555-6.862,1.909-6.627,1.909-6.627l-21.907-4.49s-3.373-20.3-4.58-26.68-2.564-13.247-7.048-19.077",
    transform: "translate(-90.464 -24.865)",
    fill: "#0d3453"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75307",
    "data-name": "Path 75307",
    d: "M125.347,123.725c-2.936-.321-7.862,1.65-9.317,4.372.61-2.862,3.647-6.008,9.017-5.987Z",
    transform: "translate(-96.774 -25.051)",
    fill: "#0b262a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46623",
    "data-name": "Group 46623",
    transform: "translate(389.91 25.254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75308",
    "data-name": "Path 75308",
    d: "M34.229,79.66A33.229,33.229,0,1,0,1,46.432,33.266,33.266,0,0,0,34.229,79.66",
    transform: "translate(-0.135 -1.779)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75309",
    "data-name": "Path 75309",
    d: "M34.094,13.933A32.364,32.364,0,1,0,66.457,46.3,32.363,32.363,0,0,0,34.094,13.933m0-1.731A34.094,34.094,0,1,1,0,46.3,34.132,34.132,0,0,1,34.094,12.2",
    transform: "translate(0 -1.644)",
    fill: "#0b3454"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75310",
    "data-name": "Path 75310",
    d: "M55.292,64.752a32.31,32.31,0,0,0,9.691,12.374q.688.545,1.4,1.038c.511-.64.8-1.012.8-1.012l3.937-25.6c-4.024.848-5.979,1.289-8.558,3.747a78.943,78.943,0,0,0-7.269,9.449",
    transform: "translate(-50.775 -6.945)",
    fill: "#e49000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75311",
    "data-name": "Path 75311",
    d: "M10.872,76.722q.688.545,1.4,1.038a32.361,32.361,0,0,0,38.264-.952c.346-.268.684-.537,1.021-.822a31.617,31.617,0,0,0,3.885-3.877,75.28,75.28,0,0,0-.623-8.653,68.543,68.543,0,0,1-.71-8.194c0-.459.009-.675.009-.675L38.138,48.556l-13.031.935-8.1,1.661C14.264,53.5,12.317,57.867,11.5,65.68c-.3,2.8-.485,6.723-.623,11.041",
    transform: "translate(3.336 -6.541)",
    fill: "#f8b018"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75312",
    "data-name": "Path 75312",
    d: "M25.675,8.473a5.406,5.406,0,0,1,4.043,3.749c.932,2.513.028,7.113-1.135,12.644s-1.93,7.906-2.672,9.452a4.191,4.191,0,0,1-2.361,2.027l-.064-6.513.08-4.543s-3.048-3.875-3.479-7.122c-.556-4.179.268-5.925.268-5.925Z",
    transform: "translate(20.87 -1.142)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75313",
    "data-name": "Path 75313",
    d: "M52.843,7.332C52.077,3.7,46.88-.645,39.567.081S28.636,2.965,26.236,7.332s-.533,7.5-.533,7.5l22.027-.876Z",
    transform: "translate(-6.297 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75314",
    "data-name": "Path 75314",
    d: "M48.911,31.5c-2.359,1.631-4.59-.766-4.59-.766l-.514,13.455s.317,2.58-3.729,5c-5.737,3.43-9,2.489-11.394,6.023-2.7-4.938-3.705-8.454.624-11.706l-.015-3.069a24.955,24.955,0,0,1-4.722.135c-3-.364-4.96-2.669-5.965-5.87-1.613-5.148-1.647-14.233.735-23.555,3.846-3.135,13.607-3.052,20.784,1.16-.137,5.954,1.6,8.54,1.666,10.7a5.64,5.64,0,0,0,1.346,1.628c1.127.911,1.932-1.572,2.816-2.565s3.846-2.393,5.441.71c1.615,3.16-.443,7.32-2.482,8.723",
    transform: "translate(1.103 -1.206)",
    fill: "#b16668"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75320",
    "data-name": "Path 75320",
    d: "M50.21,24.034c-.406,6.383-2.5,7.218-4.77,7.554-3.012.445-5.8-1-9.962-1.332-3.251-.264-4.445,1.012-6.312,1.744-1.379.542-2.471.518-2.8-1.038a40.413,40.413,0,0,1-.3-8.618,60.361,60.361,0,0,0-.267,11.6c.4,3.01,1.148,5.834,2.786,7.265,2.268,1.982,7.106,2.354,13.139,1.124,5.945-1.211,8.288-3.19,9.045-5.3,2.457-6.851,1.585-10.123,2.4-11.413s-2.951-1.582-2.951-1.582",
    transform: "translate(-7.254 -3.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75323",
    "data-name": "Path 75323",
    d: "M21.191,60.22c1.218-1.472,5.245-3.6,7.089-1.614s1.287,3.586,2.561,3.467c1.742-.163,5.286-3.349,7.07-5.291a24.809,24.809,0,0,0,3.344-5.393,10.481,10.481,0,0,1-2.6-2.438c-.972-1.385-1.147-2.743-2.22-2.825L36.314,49.2s-.7,1.531-3.747,3.586-9.157,2.667-11.376,7.436",
    transform: "translate(8.596 -6.213)",
    fill: "#dd9d15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75324",
    "data-name": "Path 75324",
    d: "M50.247,60.329c-1-.926-2.371-3.248-4.021-2.786s-2.52,3.387-2.563,2.5a25.586,25.586,0,0,1,2.785-7.875c1.258-1.858,3.314-5.055,4.415-5.239l0,2.443s-2.676,4.173-2.457,5.664,1.638,3.843,1.837,5.29",
    transform: "translate(-20.46 -6.322)",
    fill: "#e49000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75325",
    "data-name": "Path 75325",
    d: "M3.938,77.013a31.619,31.619,0,0,0,3.885-3.877A32.052,32.052,0,0,0,14.6,59.793c-1.722-1.3-4.223-2.371-8.03-3.617,0,0-.026.035-.078.112a24.566,24.566,0,0,0-3.28,10.1,32.774,32.774,0,0,0,.727,10.626",
    transform: "translate(50.957 -7.567)",
    fill: "#b16668"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75326",
    "data-name": "Path 75326",
    d: "M3.292,76.086l.337,1.661a31.508,31.508,0,0,0,4.906-4.7,32.072,32.072,0,0,0,6.845-13.62,33.5,33.5,0,0,0-8.168-3.9c-5.936,6.023-3.92,20.56-3.92,20.56",
    transform: "translate(50.245 -7.479)",
    fill: "#dd9d15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46636",
    "data-name": "Group 46636",
    transform: "translate(-218.615 62.279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75327",
    "data-name": "Path 75327",
    d: "M138.357,65.943a26.892,26.892,0,1,1,26.892-26.892,26.922,26.922,0,0,1-26.892,26.892",
    transform: "translate(424.696 19.393)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75328",
    "data-name": "Path 75328",
    d: "M138.058,12.561a26.192,26.192,0,1,1-26.191,26.191,26.191,26.191,0,0,1,26.191-26.191m0-1.4A27.592,27.592,0,1,0,165.65,38.752,27.623,27.623,0,0,0,138.058,11.16",
    transform: "translate(424.995 19.692)",
    fill: "#0b3454"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75329",
    "data-name": "Path 75329",
    d: "M164.584,40.079c-3.974,1.054-10.024,1.091-12.959-2.305-2.774-3.21-2.929-6.812-3.048-10.845a5.141,5.141,0,0,0-.223-1.529,22.744,22.744,0,0,1-.708-4.111q-.255-2.077-.324-4.17a58.346,58.346,0,0,1,.325-8.284,17.549,17.549,0,0,1,.9-4.375A7.107,7.107,0,0,1,151.21.95,6.286,6.286,0,0,1,154.471,0a8.6,8.6,0,0,1,6.882,3.581c1.576,2.275,1.661,5.225,1.735,7.99a255.4,255.4,0,0,0,2.2,27.286,1.154,1.154,0,0,1-.151.953,1.116,1.116,0,0,1-.551.267",
    transform: "translate(413.959 23.037)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75330",
    "data-name": "Path 75330",
    d: "M152.176,2.79c.677-.672,3.642-.28,5.376,1.51s2.3,4.48,1.262,5.317-7.791-4.827-6.638-6.827",
    transform: "translate(412.534 22.293)",
    fill: "#f8b018"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75331",
    "data-name": "Path 75331",
    d: "M131.174,50.561l-1.59,16.723s-2.241,2.57-4.356,5.028a26.245,26.245,0,0,1-8.908-10.147c1.667-2.57,3.256-4.916,4.1-5.959,2.745-3.375,3.852-5.014,10.749-5.644",
    transform: "translate(423.24 7.883)",
    fill: "#dd9d15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75333",
    "data-name": "Path 75333",
    d: "M157.282,62.344c-.567,2.437-1.3,5.679-2.017,9.069a25.9,25.9,0,0,1-12.339,4.013c-.553.035-1.113.056-1.674.056a26.066,26.066,0,0,1-14.587-4.44,24.178,24.178,0,0,1-2.353-1.786,25.363,25.363,0,0,1-3.179-3.193c-.007-.084-.014-.161-.014-.245-.077-3.971.959-6.1,4.524-10.6a76.638,76.638,0,0,1,5.784-6.527c.063-.063.119-.133.182-.189a1.069,1.069,0,0,1,.126-.126.743.743,0,0,1,.105-.105,1.944,1.944,0,0,1,.175-.168.673.673,0,0,1,.105-.1c.007-.014.021-.021.028-.028l.007-.007,10.469-1.646,3.543,1.106,5.651,1.758c1.583.539,7.542,4.181,5.462,13.158",
    transform: "translate(421.803 9.154)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75334",
    "data-name": "Path 75334",
    d: "M131.839,48.681c-.007.007-.021.014-.028.028a.672.672,0,0,0-.105.1,1.944,1.944,0,0,0-.175.168.743.743,0,0,0-.105.105,1.069,1.069,0,0,0-.126.126c-.063.056-.119.126-.182.189-2.353,2.633-4.86,8.06-5.812,11.478-.686,1.562-1.085,4.937-1.3,9.09a25.363,25.363,0,0,1-3.179-3.193c-.259-.3-.5-.616-.742-.931a13.813,13.813,0,0,1,1.4-5c1.653-3.137,7.878-10.819,10.357-12.157",
    transform: "translate(422.113 8.447)",
    fill: "#f8b018"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75336",
    "data-name": "Path 75336",
    d: "M137.182,47.854c-1.742,1.195-9.532,6.548-11.081,16.972a28.731,28.731,0,0,1,3.372-12.9c2-3.252,4.66-6.289,7.644-7.173Z",
    transform: "translate(420.309 9.623)",
    fill: "#f8b018"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75337",
    "data-name": "Path 75337",
    d: "M166.507,70.123c-.294.231-.588.448-.889.658-.336.238-.679.462-1.022.679a25.9,25.9,0,0,1-12.339,4.013c-.014-1.022-.014-2.059-.007-3.1.049-7.08,3.137-21.842,3.221-23.8.021-.455.028-.812.028-1.092a3.706,3.706,0,0,0-.028-.994l4.489,1.877s3.046.805,4.965,1.4c2.318.728,2.1,3.5,2.472,6.59.448,3.81-.231,8.971-.889,13.775",
    transform: "translate(412.474 9.106)",
    fill: "#f8b018"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75339",
    "data-name": "Path 75339",
    d: "M128.741,6.229c-4.749.206-7.446,7.361-4.178,12.359,5.793,8.861,19.695,3.624,19.695,3.624l2.571,7.527s2.622-2.9,4.4-5.3c3.209-4.322,3.557-14.607-1.665-15.629.771-5.3-13.83-11.792-20.824-2.583",
    transform: "translate(421.201 22.558)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75340",
    "data-name": "Path 75340",
    d: "M130.038,13.289c-.772,1.561-2.615,3.921-2.328,12.583.225,6.765,2.578,8.245,4.8,9.108a11.821,11.821,0,0,0,5.084.165l.061,3.172s-4.217,3.883-2.88,11.7c13.105-5.466,13.259-12.125,13.259-12.125l.357-10.574c.426.69,2.5,1.623,4.134-.463,1.919-2.452,1.491-5.378-.217-6.456-1.768-1.116-3.793-.057-4.574,1.943-1.84.765-4.28-1.142-4.162-8.258-2.246-1.176-6.618.487-8.02.328-2.1-.238-3.347-2.279-5.515-1.12",
    transform: "translate(419.836 19.16)",
    fill: "#ffbda7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75342",
    "data-name": "Path 75342",
    d: "M141.837,42.149c5.692-1.228,8.885-3.539,9.468-5.842,0,0-.361,3.013-1.959,4.342-2.242,1.863-7.479,3.073-7.479,3.073Z",
    transform: "translate(415.593 12.155)",
    fill: "#f0997a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75350",
    "data-name": "Path 75350",
    d: "M155.553,43.583c.873-.042,1.1.5,2.258,1.811a16.817,16.817,0,0,0,2.176,2.092c-1.068,6.5-6.186,14.6-7.644,22.233-.062-6.178,1.592-14.671,3.157-24.11Z",
    transform: "translate(412.444 9.975)",
    fill: "#f8b018"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75351",
    "data-name": "Path 75351",
    d: "M179.237,60.258a26.207,26.207,0,0,1-9.37,11.926c-1.155-2.108-2.059-3.641-2.059-3.641s-3.887-10.854,1.366-17.381c4.4,1.043,6.709,2.339,8.1,5.133.609,1.233,1.282,2.542,1.968,3.964",
    transform: "translate(408.224 7.703)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46635",
    "data-name": "Group 46635",
    transform: "translate(574.648 58.865)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46634",
    "data-name": "Group 46634",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46633",
    "data-name": "Group 46633",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75352",
    "data-name": "Path 75352",
    d: "M179.237,60.258a26.207,26.207,0,0,1-9.37,11.926c-1.155-2.108-2.059-3.641-2.059-3.641s-3.887-10.854,1.366-17.381c4.4,1.043,6.709,2.339,8.1,5.133.609,1.233,1.282,2.542,1.968,3.964",
    transform: "translate(-166.424 -51.161)",
    fill: "#dd9d15"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManage);
export default __webpack_public_path__ + "static/media/manage.d54d9ab0ae739e3819c0899546353b98.svg";
export { ForwardRef as ReactComponent };